import React, { PureComponent } from 'react'
import './welcomePage.less'
import API from '../../../api/api';


class WelcomePageComponent extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            loginStatus:''
        }
    }

    componentDidMount() {

    }

    render() {
        const {loginStatus} = this.state;
        return (
            <div className="welcome-page">
                <span className='red'>请登录铛铛运营管理系统</span>
            </div>
        );
    }
}

export default WelcomePageComponent